var map = {
	"./B_off.png": 3611,
	"./B_on.png": 6193,
	"./Load.png": 2911,
	"./MEDIVER CI.png": 1733,
	"./RX_W.png": 1427,
	"./Register.png": 6576,
	"./arrow-down_thin.png": 333,
	"./arrow-left_thin.png": 9828,
	"./arrow-up_thin.png": 1344,
	"./back.png": 9450,
	"./bluetooth.png": 7285,
	"./body_shape.png": 9885,
	"./charging_battery_151.png": 6714,
	"./check.png": 8515,
	"./diagnosis.png": 7804,
	"./edit.png": 5543,
	"./error.png": 7473,
	"./full_battery_151.png": 7576,
	"./home-1_duotone 2.png": 4063,
	"./home.png": 6462,
	"./hover_logo.png": 6595,
	"./icon.png": 1336,
	"./list-icon.png": 8417,
	"./logo.png": 4582,
	"./mediver_ci.png": 9478,
	"./prescription.png": 8259,
	"./register-icon.png": 2996,
	"./setting.png": 6375,
	"./trash.png": 8461,
	"./user 2.png": 6040,
	"./vas_score_10.png": 648,
	"./vas_score_100.png": 8106,
	"./vas_score_20.png": 4317,
	"./vas_score_30.png": 1842,
	"./vas_score_40.png": 5631,
	"./vas_score_50.png": 2628,
	"./vas_score_60.png": 7929,
	"./vas_score_70.png": 3518,
	"./vas_score_80.png": 2907,
	"./vas_score_90.png": 5008
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4699;